import { useLocaleField } from '@/hooks/useLocaleField';
import { Box, Container, Divider, Flex, Heading, Text } from '@chakra-ui/react';
import { PortableText } from '@portabletext/react';
import { FC } from 'react';
import cn from 'classnames';
import { RoomActions } from '../RoomActions';
import styles from './RoomDetailsInfo.module.css';
import { RoomDetailsInfoProps } from './RoomDetailsInfo.props';

const RoomDetailsInfo: FC<RoomDetailsInfoProps> = ({ room }) => {
  const { getLocaleField, getLocaleBlock } = useLocaleField();

  return (
    <Container maxW="8xl">
      <Flex direction={{ base: 'column', md: 'row' }}>
        <Box w={{ base: '100%', md: '60%' }} mt={{ base: '2rem', md: '4rem' }}>
          <Heading mb="0.5rem" fontWeight="normal" as="h2" fontSize="5xl" color="blue.800">
            {getLocaleField(room.name)}
          </Heading>
          {/* <Price price={data.room_price} /> */}
          <Divider my="25px" />
          <Box mb="4rem" lineHeight="2rem">
            <PortableText value={getLocaleBlock(room.description)} />
          </Box>

          <Heading mb="1rem" as="h4" fontWeight="normal" color="gray.700" fontSize="2xl">
            Amenities
          </Heading>
          <Flex
            borderRadius="sm"
            p={{ base: '10px', md: '15px' }}
            mb="2rem"
            className={styles.FeaturesList}
            flexWrap="wrap"
          >
            {room.room_features?.map((feature) => (
              <Box w={{ base: '50%', md: '33%' }} p="15px 0" key={feature?._id}>
                <Box mr="30px" mb="15px" className={styles.room_feature}>
                  <Flex alignItems="center">
                    <span className={cn('icon', `icon-${feature?.icon}`, styles.icon)} />
                    <Text display="inline-block" ml="5px" as="span">
                      {getLocaleField(feature?.name)}
                    </Text>
                  </Flex>
                </Box>
              </Box>
            ))}
          </Flex>
          <Flex
            as="div"
            borderStartRadius="sm"
            p={{ base: '10px', md: '15px' }}
            color="blue.900"
            backgroundColor="primary-200"
          >
            <span
              className={cn('icon', 'icon-info')}
              style={{ display: 'inline-block', marginRight: 10, fontSize: '1.5rem' }}
            />

            <PortableText value={getLocaleBlock(room.note)} />
          </Flex>
        </Box>
        <Box position="relative" w={{ base: '100%', md: '40%' }}>
          <RoomActions room={room} />
        </Box>
      </Flex>
    </Container>
  );
};

export { RoomDetailsInfo };
